import AutoCompleteSolo from "../../../utils/FormikFields/AutoCompleteSolo";

import { Link } from "react-router-dom";

import { Grid, Button } from "@mui/material";

import { useFormikContext } from "formik";

import { InputLabel, BasicFlex } from "../../../utils/Common";

const ContactGroups = ({ }) => {
  return (
    <Grid item size={{xs: 12}} >
    <InputLabel>Select Contact Group (Optional)</InputLabel>
    <AutoCompleteSolo 
      name="contact_group"
      fieldName="name"
      label="Contact Group" 
      url="contact_groups" 
    />
    <BasicFlex justify="flex-end">
      <Link to="/contact_groups/edit">
        <Button type="button" size="small" color="info">Create New Contact Group</Button>
      </Link>
    </BasicFlex>
    </Grid>
  );
};

export default ContactGroups;